import { createContext, useEffect, useState } from "react";
import {
  addNewLoyalty,
  deleteLoyalty,
  getLoyalty,
  orderBasedInitial,
  visitBasedInitial,
  feedbackBasedInitial,
} from "../utils/loyalty-edit";
export const LoyaltyContext = createContext({});
export const LoyaltyProvider = ({ children }) => {
  const [pointsLoyalty, setPointsLoyalty] = useState({});
  const [loyaltyDetails, setLoyaltyDetails] = useState({});
  const [order_based_rewards, setOrderBasedRewards] = useState({});
  useEffect(() => {
    getLoyalty(setPointsLoyalty);
  }, []);
  useEffect(() => {
    if (Object.keys(pointsLoyalty).length !== 0) {
      setLoyaltyDetails(pointsLoyalty["details"]);
    }
  }, [pointsLoyalty]);
  const addLoyalty = (fields) => {
    const hotelID = localStorage.getItem("hotelID");
    const newObject = { ...fields, ["hotelID"]: hotelID };
    console.log(newObject);
    addNewLoyalty(newObject, setPointsLoyalty);
  };
  const addOrderRewards = () => {};
  const deleteFunction = () => {
    deleteLoyalty(setPointsLoyalty);
  };
  const value = {
    pointsLoyalty,
    order_based_rewards,
    setOrderBasedRewards,
    setPointsLoyalty,
    addLoyalty,
    deleteFunction,
    loyaltyDetails,
  };
  return (
    <LoyaltyContext.Provider value={value}>{children}</LoyaltyContext.Provider>
  );
};
